const adaptiveDrawers = [
    {
        selector: '[data-react="adaptiveDrawers"]',
        path: { filename: 'App' },
    },
];

export { adaptiveDrawers };
